/**
* 图表界面
*/
<template>
	<!-- 组件主盒子 -->
	<div class="stbox">
		<!-- 面包屑导航 -->
    <div class="home-header" style="margin-bottom: 0;">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>数据分析</el-breadcrumb-item>

			<el-select style="margin-left: 20px;" v-model="getJZ" placeholder="选择部门" @change="handleNodeClick" size="small" v-if="user.username == 'admin'">
				 <el-option
				   v-for="item in deptData"
				   :key="item.id"
				   :label="item.departmentName"
				   :value="item.id">
				 </el-option>
			</el-select>
		</el-breadcrumb>
    </div>


		<el-row :gutter="23">
			<el-col :span="9" >
        <div class="tbox">
				<el-row type="flex" justify="space-between" class="title-border"  >
				  <el-col>
					<h3 class="h-title"><i class="el-icon-date"></i> 能耗日历</h3>
				  </el-col>
				</el-row>
				<el-row :gutter="4">
					<el-col :span="16">
						<el-calendar v-model="cdate">
					  <template slot="dateCell" slot-scope="{date, data}" >
						 <span @click="getDate(data)">{{ data.day.substring(8)}}</span>
					  </template>

					</el-calendar>
					</el-col>
					<el-col :span="8" style="height: 280px;">
            <div class="riliBox">
              <div class="yl-content">
                <el-scrollbar style="height: 100%;">
                  <ul>
                    <li v-for="item in riliData">
                      <img src="../../assets/img/power.png"  v-if="item.mapKey == 15"/>
                      <img src="../../assets/img/water.png"  v-if="item.mapKey == 16"/>
                      <h4>{{item.label}}<span class="sunit">({{ getUnit(item.mapKey) }})</span></h4>
                      <p style="color:#1485D5">{{item.data}}</p>
                    </li>
                  </ul>
                </el-scrollbar>
              </div>

            </div>

					</el-col>
				</el-row>
        </div>
      </el-col>
			<el-col :span="8" class="re">
        <div class="tbox">
          <el-row type="flex" justify="space-between" class="title-border">
            <el-col>
            <h3 class="h-title"><i class="el-icon-pie-chart"></i> 能耗用途统计</h3>
            </el-col>
            <el-col style="line-height: 60px;">
            <el-radio-group v-model="timeType" @change="getpay">
             <el-radio label="day">昨天</el-radio>
             <el-radio label="month">当月</el-radio>
             <el-radio label="year">当年</el-radio>
            </el-radio-group>
            </el-col>
          </el-row>

          <div class="paybox" >
            <p style="text-align: center;color: ddd; font-size: 14px;" v-if="noData">暂无数据</p>
            <div class="cavasbox" ref="payEchart"></div>
          </div>
          <div class="ntype">
           <el-radio-group v-model="ntype" size="mini" @change="getpay">
            <el-radio-button :label="15">电</el-radio-button>
            <el-radio-button :label="16">水</el-radio-button>
            <el-radio-button :label="18">热能</el-radio-button>
           </el-radio-group>
          </div>
        </div>
			</el-col>
			<el-col :span="7" >
        <div class="tbox re">
         <h3 class="h-title title-border"><i class="el-icon-odometer"></i>设备总览统计</h3>
            <div class="meter-contet">

              <el-carousel >
                <el-carousel-item indicator-position="outside">
                  <div class="outbox">
                      <div class="meterBox power">
                        <h3>电表数量</h3>
                        <p  >{{powerMeteNum}}<span style="font-size:16px; position: relative;top: -5px;">（只）</span></p>
                      </div>

                      <div class="meterBox water">
                        <h3>水表数量</h3>
                        <p >{{waterMeteNum}}<span style="font-size:16px; position: relative;top: -5px;">（只）</span></p>
                      </div>
                     <div class="meterBox zd">
                       <h3>终端数量</h3>
                       <p>{{terCount}}<span style="font-size:16px; position: relative;top: -5px;">（只）</span></p>
                     </div>

                     <div class="meterBox zdOnline">
                       <h3>终端在线数量</h3>
                       <p >{{terOnlineCount}}<span style="font-size:16px; position: relative;top: -5px;">（只）</span></p>
                     </div>
                    </div>
                </el-carousel-item>
                <!-- <el-carousel-item >
                  <div class="outbox">
                      <div class="meterBox power">
                        <h3>热能表数量</h3>
                        <p  >{{hotNum}}<span style="font-size:16px; position: relative;top: -5px;">（只）</span></p>
                      </div>



                    </div>
                </el-carousel-item> -->

              </el-carousel>

            </div>
        </div>


			</el-col>
		</el-row>
		<el-row :gutter="23">
				<el-col :span="12">

          <div  class="sbox1">
            <el-row type="flex" justify="space-between">
              <el-col>
                 <h3 class="h-title"><i class="el-icon-s-data"></i> 能耗分类</h3>
              </el-col>
              <el-col style="line-height: 60px;text-align: center;">
                <el-radio-group v-model="ftimeType" @change='getFenLei'>
                  <!-- <el-radio label="time">逐时</el-radio> -->
                  <el-radio label="month">逐日</el-radio>
                  <el-radio label="year">逐月</el-radio>

                </el-radio-group>
              </el-col>

            </el-row>
            <div class="paybox">
              <div class="cavasbox" ref="fengLei"></div>
            </div>
          </div>
				</el-col>
				<el-col :span="12"  >
          <div class="sbox1">
            <el-row type="flex" >
              <el-col >	<h3 style="color: #F56C6C;"  class="h-title"><i style="color: #F56C6C;" class="el-icon-warning"></i> 异常表数据</h3></el-col>
              <el-col >
                <div style="line-height: 60px; float: right;">
                 <el-radio-group v-model="unusualType" size="mini" @change="changeUnusua">
                  <el-radio-button :label="15">电</el-radio-button>
                  <el-radio-button :label="16">水</el-radio-button>
                  <el-radio-button :label="18">热能</el-radio-button>
                 </el-radio-group>
                </div>
              </el-col>
            </el-row>


            <el-table size="small" :header-cell-style="{background:'#9495FF',color:'#ffffff'}"  :data="unusualData"  v-loading="loadingUnusual"  element-loading-text="加载中" style="width: 100%;" stripe height="300">
              <el-table-column align="center"  type="index" width="60">
              </el-table-column>
              <el-table-column label="计量点名称" prop="name">
              </el-table-column>
            </el-table>
          </div>
				</el-col>

		</el-row>



    <el-dialog :title="title" :visible.sync="editFormVisible" @click="editFormVisible = false" width="42%">

    <!--  <el-table size="small" :data="dialogData"  v-loading="loading" border element-loading-text="加载中" style="width: 100%;" stripe height="300">
        <el-table-column align="center"  type="index" width="60">
        </el-table-column>
        <el-table-column label="计量点名称" prop="name">
        </el-table-column>
      </el-table> -->
    </el-dialog>

    <!-- 能耗日历选择能源分项 -->
    <el-dialog title="选择能源分项" width="500px" :visible.sync="showEnegrySub">
      <el-form label-width="120px" >
        <el-form-item label="能源种类" >
          <el-select  placeholder="请选择" size="small"  v-model="riliFrom.energyType" @change="changeSub">
            <el-option v-for="item in energyTypeData" :label="item.energyTypeName" :value="item.energyTypeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="能源分项" >
          <el-select  placeholder="选择能源分项" size="small" v-model="riliFrom.energyDataItemId">
             <el-option label="无分项" value="" v-if="energyTypeData.length"></el-option>
            <el-option v-for="item in subTypeData" :label="item.energyDataName" :key="item.id" :value="item.energyDataId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='showEnegrySub = false'>取消</el-button>
        <el-button size="small" type="primary" @click="getDataByDate()">确认</el-button>
      </div>
    </el-dialog>
     <!-- 能耗日历选择分类分项 -->
    <!-- <el-dialog title="选择能源分项" width="500px" :visible.sync="showEnegryFl">
      <el-form label-width="120px" >
        <el-form-item label="能源种类" >
          <el-select  placeholder="请选择" size="small"  v-model="fenLeiForm.energyType" @change="changeSub">
            <el-option v-for="item in energyTypeData" :label="item.energyTypeName" :value="item.energyTypeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="能源分项" >
          <el-select  placeholder="选择能源分项" size="small" v-model="fenLeiForm.energyDataItemId">
            <el-option label="无分项" value="" v-if="energyTypeData.length"></el-option>
            <el-option v-for="item in subTypeData" :label="item.energyDataName" :key="item.id" :value="item.energyDataId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='showEnegryFl = false'>取消</el-button>
        <el-button size="small" type="primary" @click="getFenLei()">确认</el-button>
      </div>
    </el-dialog> -->


	</div>
</template>
<script>
import Chart from 'echarts'
import 'echarts/theme/macarons.js'
import { getAllMeter,findEnergyDay,findEnergyYtList,findEnergyBranchList,getDeps,getUnusual,getTerminalCount } from '../../api/dataMG.js'
import { getEnegySubItem} from '../../api/energyMG'
import { timestampToTime } from '../../utils/util'
import RowBox from "@/components/rowBox";
export default {
	name: "welcome",
	data() {
		return {
      showEnegrySub:false,
      showEnegryFl:false,
			radio: 1,
			machineNo: '',
      loading:false,
			type: 'day',
      title:'',
      date:"",
      editFormVisible:false,
      riliData:[],
      unWaterData:[],
      unHotData:[],
      unPowerData:[],
      unusualData:[],
      cdate:new Date()-24 * 60 * 60 * 1000,
      dataDate:'',
			indexData:{},
      waterMeteNum:0,
      powerMeteNum:0,
      hotNum:0,
      unusualType:15,
      ntype:15,
      loadingUnusual:false,
      deptData:[],

      energyTypeData:[],
      noData:false,
      subTypeData:[],
			user:{},
      getJZ:"",
      dayData:"",
      monthDate:"",
      departmentId:"",
      timeType:"month",
      ftimeType:"month",
      riliFrom:{
        date:"",
        departmentId:'',
      },

      fenLeiForm:{
        timeType:"",
        energyType:'',
      },
      terCount:0,//终端数量
      terOnlineCount:0
		}
	},
	// 导入组件
	components: {
		RowBox
	},

	created() {

	},
	// 挂载结束状态(里面是操作)
	 mounted() {
    this.user = JSON.parse(sessionStorage.getItem('userdata'))


    this.date = timestampToTime(new Date() -  24 * 60 * 60 * 1000).substring(0,10)

    if(this.user.username == 'admin'){
      this.getDeptData().then(res => {
        this.departmentId = res[0].id
        this.getData()
        this.getUnusualData() //异常表数据
        this.getFenLei();//分类统计
        this.getDataByDate() //能耗日历
        this.getpay()  //能耗用途统计
        this.getZdData()

      });
    }else{
       //能源分项
      this.getFenLei();//分类统计
      this.getDataByDate() //能耗日历
      this.getpay()  //能耗用途统计
      this.getUnusualData()
      this.getData()
      this.getZdData()

    }



     this.$nextTick(() => {
        // 点击前一个月
        let prevBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(1)');
        let minBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(2)');
        let nextBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(3)');
        prevBtn.addEventListener('click',() => {
          this.date = timestampToTime(this.cdate).substring(0,10)
          this.getDataByDate()
        })
        minBtn.addEventListener('click',() => {
          this.date = timestampToTime(this.cdate).substring(0,10)
          this.getDataByDate()
        })

        nextBtn.addEventListener('click',() => {
          this.date = timestampToTime(this.cdate).substring(0,10)
          this.getDataByDate()
        })
      })
	},

	methods: {



    //获取部门
    getDeptData:function(){
    	return new Promise((resolve,reject) => {
    		getDeps({ accountType:3 }).then(res => {
    			if(res.status == 1){
    				let arr = []
    				this.deptData = res.data
            this.getJZ = res.data[0].departmentName
    				resolve(res.data)
    			}
    			else{
    				this.$message.error(res.msg)
    			}
    		})
    	})
    },

    getUnit(key){
      if(key == '15'){
        return 'kWh'
      }else if(key == '16' || key == '18'){
        return 'm³'
      }else{
        return ''
      }
    },

    handelSub(){
      this.showEnegrySub = true
    },
    handelFl(){
      this.showEnegryFl = true
    },

    //获取异常表数据
    getUnusualData(){
      let param = {
        departmentId:this.departmentId
      }
      this.loadingUnusual = true
      this.unusualData = []
      getUnusual(param).then(res => {
        this.loadingUnusual = false
        if(res.status == 1){
          this.unPowerData = res.data.power.map( item => {  return { name:item } })
          this.unWaterData = res.data.water.map( item => {  return { name:item } })
          this.unHotdata = res.data.hot.map( item => {  return { name:item } })
          this.unusualData = this.unPowerData
        }
      })

    },

    changeSub(e){
      this.subTypeData = []
      this.subTypeData = this.energyTypeData.filter( item => item.energyTypeId == e)[0].DepartmentEnergyData
    },

    //能耗用途统计
		getpay() {
      let param = {
        timeType:this.timeType,
        departmentId:this.departmentId,
        energyType:this.ntype
      }
      findEnergyYtList( param).then(res => {
        if( res.status == 1 ){
          let lenData = []
          this.noData = res.data.length == 0 ? true:false
          res.data.forEach(item => {
            lenData.push(item.name)
          })


          let option = {
            tooltip: {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
              orient: 'vertical',
              x: 'left',
              data: lenData
            },
            toolbox: {
              show: true,
              feature: {
                mark: {
                  show: true
                },
                magicType: {
                  show: true,
                  type: ['pie', 'funnel'],
                  option: {
                    funnel: {
                      x: '25%',
                      width: '50%',
                      funnelAlign: 'left',
                      max: 1548
                    }
                  }
                },
              }
            },
            calculable: true,
            series:
              [{
                name: '能耗用途统计',
                type: 'pie',
                radius: '55%',
                center: ['50%', '50%'],
                data: res.data,
                label: {
                  normal: {
                    show: true,
                    formatter: "{b}\n({d}%)"
                  }
                }
              }]
          }
          this.chart = Chart.init(this.$refs.payEchart, 'macarons')
          this.chart.setOption(option)
        }


      })
		},

  getZdData(){
    let param = {
      departmentId:this.departmentId
    }
    getTerminalCount(param).then(res => {
      if(res.status == 1){
        this.terCount = res.data.terCount
        this.terOnlineCount = res.data.terOnlineCount
      }
    })
  },

    //能耗分类统计
    getFenLei() {
      //findEnergyBranchList

      let dateStr = ''
      if( this.ftimeType == 'month' ){
         dateStr = timestampToTime(new Date()).substring(0,4)
      }else if( this.ftimeType == 'day'){
         dateStr = timestampToTime(new Date()).substring(0,7)
      }else {
        dateStr = timestampToTime(new Date()).substring(0,10)
      }


      this.fenLeiForm.timeType = this.ftimeType
      this.fenLeiForm.departmentId = this.departmentId
      findEnergyBranchList(this.fenLeiForm).then(res => {
        this.showEnegryFl = false
        if(res.status == 1){
          let option = {
          	tooltip: {
          		trigger: 'axis'
          	},
          	legend: {
          		data: ['电力（千瓦时）', '水（立方米）', '热能（立方米）'],
          	},
          	toolbox: {
          		show: true,
          		feature: {
          			mark: {
          				show: true
          			},
          			dataView: {
          				show: true,
          				readOnly: false
          			},
          			magicType: {
          				show: true,
          				type: ['line', 'bar']
          			},
          			restore: {
          				show: true
          			},
          			saveAsImage: {
          				show: true
          			}
          		}
          	},
          	calculable: true,
          	xAxis: [{
          		type: 'category',
          		data: res.data.dayList
          	}],
          	yAxis: [
              {
                type: 'value',
                axisLabel : {
                    formatter: '{value}',
                    textStyle: {
                        color: '#2ec7c9'
                    }
                }
              },
              {
                //第二条Y轴
                type:'value',
                splitNumber : 5,
                axisLabel : {
                    formatter: '{value}',
                    textStyle: {
                        color: '#b6a2de'
                    }
                }

              }

            ],
          	series: [
              {
          			name: '电力（千瓦时）',
          			type: 'bar',
          			data: res.data['15'],
               // label: {
               //   normal: {
               //       show: true,

               //   }
               // },
          			markPoint: {
          				data: [{
          						type: 'max',
          						name: '最大值'
          					},
          					{
          						type: 'min',
          						name: '最小值'
          					}
          				],

          			},
          			// markLine: {
          			// 	data: [{
          			// 		type: 'average',
          			// 		name: '平均值'
          			// 	}]
          			// }
          		},
              {
              	name: '水（立方米）',
              	type: 'bar',
                // label: {
                //   normal: {
                //       show: true,

                //   }
                // },
              	data: res.data['16'],
                 yAxisIndex : '1',
              	markPoint: {
              		data: [{
              				type: 'max',
              				name: '最大值'
              			},
              			{
              				type: 'min',
              				name: '最小值'
              			}
              		],

              	},

              },
              {
              	name: '热能（立方米）',
              	type: 'bar',

              	data: res.data['18'],
                 yAxisIndex : '1',
              	markPoint: {
              		data: [{
              				type: 'max',
              				name: '最大值'
              			},
              			{
              				type: 'min',
              				name: '最小值'
              			}
              		],

              	},

              }
          	]
          }
          this.chart = Chart.init(this.$refs.fengLei, 'macarons')
          this.chart.setOption(option)

        }
      })
		},

    //能耗日历
    getDataByDate(){
      this.riliFrom.date = this.date
      this.riliFrom.departmentId = this.departmentId

      findEnergyDay(this.riliFrom).then(res => {
        if(res.status == 1){
          this.riliData = res.data
          this.showEnegrySub = false
        }
      })
    },

    handleNodeClick(e){
      this.departmentId = e
      this.getData()
      this.getUnusualData()
      this.getDataByDate()
      this.getpay()
      this.getFenLei()
	this.getZdData()
      this.unusualType = 15
      this.riliFrom.energyDataItemId = ''

    },

    showDialog(type){
      this.editFormVisible = true
      if(type == 'nobind'){
        this.title = '未开户数据'

        this.dialogData = []
        this.unuser.forEach(item => {
          this.dialogData.push({
            name:item
          })
        })
      }else if( type == 'qf'){
        this.title = '欠费数据'
        this.dialogData = []
        this.indexData.qfRunningList.forEach(item => {
          this.dialogData.push({
            name:item
          })
        })
      }
    },




    getDate(val){
      this.date = val.day
      this.getDataByDate()
    },

    changeUnusua(e){

     if(this.unusualType == 15){
       this.unusualData = this.unPowerData
     }else if(this.unusualType == 16){
       this.unusualData = this.unWaterData
     }else if(this.unusualType == 18){
       this.unusualData = this.unHotdata
     }
    },
    //获取水电表数据
		getData(){
      this.loading  = true
     this.powerMeteNum = 0
     this.waterMeteNum = 0
     this.hotNum = 0
      getAllMeter({departmentId:this.departmentId}).then(res =>{
        this.loading = false
				if( res.status == 1){
          res.data.forEach(item => {
            if(item.energyType == '15'){
              this.powerMeteNum = item.count
            }else if(item.energyType == '16'){
              this.waterMeteNum = item.count
            }else{
              this.hotNum = item.count
            }
          })
				}
			}).catch(err =>{
        this.loading = false
				 this.$message.error('获取数据失败，请稍后再试！')
			})
		}
	}
};
</script>
<style>
  .el-carousel__arrow{
    opacity:0;
  }
  .el-carousel__indicators--horizontal{
    bottom: 6px;

  }
  .el-carousel__button{
    background: rgb(121, 187, 255);
  }
  .tj-t{
    font-weight: bold;
  }
  .yl-content {
    padding: 30px 5px 0 10px;
    height: 260px;
  }
  .yl-content  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .yl-content ul{
    margin: 0;
    padding: 0;

  }
  .yl-content li{
    list-style: none;
    padding-left: 30px;
    padding-bottom: 16px;
    position: relative;
    border-bottom: 1px solid #ccc;
  }
  .yl-content li img{
    position: absolute;
    left: 0;
    top: 20px;
    width: 18px;
    height: 18px;
  }
  .yl-content h4{
    font-size: 14px;
    margin: 0;
    line-height: 50px;
  }
  .yl-content p{
    font-size: 24px;
    margin: 0;
  }
  .home-header{
    background: #fff;
    line-height: 65px;
    margin-bottom: 20px;
    padding-left: 20px;
  }
  .home-header .el-breadcrumb{
     line-height: 65px;
  }
  .meter-contet{
    width: 312px;
    overflow: hidden;
    position: absolute;
    padding-top: 20px;
    left: 50%;
    transform: translate(-50%,0)
  }
  .outbox{
    width: 470px;
  }
  .meterBox{
     float: left;
     text-align: center;
     width: 140px;
     height: 120px;
     margin: 10px;
     color: #fff;
    overflow: hidden;
   }
  .stbox {
    margin: 0;
    margin: -10px;
    padding: 10px 10px 50px 10px;
  	box-sizing: border-box;
    background: #ebebeb;
    min-height: 100%;
  }


   .meterBox h3{
     font-weight: normal;
     font-size: 18;
     margin: 0;
     margin-top: 20px;
     line-height: 40px;
   }
   .meterBox p{
     font-size: 24px;
     margin: 0;
   }
   .meterBox.water{
     background: url('../../assets/img/w_bg.png');
     background-size: 100% 100%;
   }
   .meterBox.power{
     background: url('../../assets/img/p_bg.png');
     background-size: 100% 100%;
   }
   .meterBox.zd{
     background: url('../../assets/img/zd.png');
     background-size: 100% 100%;
   }
   .meterBox.zdOnline{
     background: url('../../assets/img/zdon.png');
     background-size: 100% 100%;
   }
   .rili-radio{
     text-align: center;
     padding-top: 20px;
     width: 100%;
   }

  	.sbox1 .data-list{
  		font-size: 14px;
  		line-height: 30px;
  		height: 300px;
  	}
  	.tbox .data-list{
  		overflow-y:auto;
  		font-size: 14px;
  		line-height: 30px;
  		height: 300px;

  	}

  	.el-calendar-table .el-calendar-day {
  		height: 30px;
  	}

  	.el-backtop,
  	.el-calendar-table td.is-today {
  		background: #ccc;
  		color: #FFFFFF;
  	}
  .el-calendar-table td.is-selected {
   	background: #409EFF;
     color: #FFFFFF;
   }
   .re{
     position: relative;
   }
   .el-calendar-table td .el-calendar-day:hover {
    	background: #409EFF !important;
     	color: #FFFFFF;

    }

  	.h-title{
  		color: #fff;
  		line-height: 60px;
  		margin: 0;
  		font-size: 24px;
      text-align: center;
  		font-weight: normal;
      margin-top: 20px;
  	}
    .tbox .h-title{

      color: #2F308D;
      text-align: left;
      line-height: 60px;
      margin: 0;
      padding-top:0 ;
      padding-left: 22px;
    }
    .sbox1 .h-title{
      color: #2F308D;
      line-height: 60px;
      margin: 0;
      text-align: left;
      font-size: 24px;
      font-weight: normal;
    }
    .title-border{
       border-bottom:1px solid #E5E5E5;
    }
    .fbox p{
      font-size: 20px;
      transition: 0.2s;
      text-align: center;
      margin: 0;
    }
  	.tj-title {
  		line-height: 60px;
  		color: #666;
  		font-size: 14px;
  		text-align: right;

  	}

  	.tbox {

      background: #fff;
  		height: 380px;
  		overflow: hidden;
      margin-top: 20px;
      border-radius: 4px;
  	}
    .fbox {
    	height: 150px;
    	overflow: hidden;
      transition: 0.4s;
      padding:0 ;
      margin: 0;
      position: relative;

    }
    .tItem{
      height: 100%;
      cursor: pointer;
      margin: 0;
      transition: 0.4s;
      padding: 0;
      overflow: hidden;
      position: relative;
    }
    .tItem .t-icon{
      position: absolute;
      right: 20px;
      top: 10px;
    }
    .tItem.t1{
      background: url(../../assets/img/t1.png);
      background-size: 100% 100%;
    }
    .tItem.t2{
      background: url(../../assets/img/t2.png);
      background-size: 100% 100%;
    }
    .tItem.t3{
      background: url(../../assets/img/t3.png);
      background-size: 100% 100%;
    }
    .tItem.t4{
      background: url(../../assets/img/t4.png);
      background-size: 100% 100%;
    }
    .tItem.t5{
      background: url(../../assets/img/t5.png);
      background-size: 100% 100%;
    }

    .fbox.cc:hover{
      background: #f4f4f4;

    }
    .fbox:hover p{
      transform: scale(1.2);
    }
    .sunit{
      font-size: 12px;
      padding: 0 4px;
      color: #3A8EE6;
    }


  	.sbox1 {
      margin-top: 20px;
      background: #fff;
  		height: 380px;
      overflow: hidden;
      border-radius: 8px;
      padding: 0 20px;
  	}

   .el-calendar-day{
     position: relative;
   }
   .el-calendar-day span{
     position: absolute;
     top: 0;
     bottom: 0;
     right: 0;
     left: 0;
     text-align: center;
     padding-top: 6px;
   }


  	.box-card {
  		margin-bottom: 14px;
  	}
   .ntype{
     position: absolute;
     bottom: 20px;
     left: 20px;
   }

    .el-col-xl-4-8{
      width: 20%;
    }
    .el-col-lg-4-8{
      width: 20%;
    }
    .el-col-md-4-8{
      width: 20%;
    }
    .el-col-sm-4-8{
      width: 20%;
    }
    .el-col-xs-4-8{
      width: 20%;
    }

  	.el-calendar__body {
  		padding: 12px 10px
  	}
   .el-calendar__header{
     padding: 10px;
   }


  	.stbgc {
  		background-color: #fff;
  		height: 60px;
  		line-height: 60px;
  		border-radius: 5px;
  		padding: 0px 16px;
  	}

  	.stsearch {
  		text-align: center;
  	}

  	.text-c {
  		text-align: center;
  	}

  	.st-gbox {
  		background-color: #fff;
  		margin-top: 20px;
  		border-radius: 5px;
  		height: 30vh;
  		box-sizing: border-box;
  		padding: 10px;
  	}

  	.cavasbox {
  		box-sizing: border-box;
  		width: 100%;
  		height: 100%;
  	}

  	.paybox {
  		width: 100%;
  		background-color: #fff;
  		box-sizing: border-box;
  		border-radius: 5px;
      overflow: hidden;
  		height: 32vh;
  	}

  	.el-calendar__title {
  		font-size: 14px;
  	}

  	.el-calendar-table {
  		font-size: 14px;
  	}
    .unit{
      font-size: 16px;
      padding-left: 10px;
      position: relative;
      top: -2px;
    }

  	/* .el-card__header {
  		padding: 14px 20px;

  	} */

  /* 	.zl-item {
  		color: #fff;
  		padding: 20px;
  		height: 112px;
  		margin-bottom: 4px;
  	}

  	.zl-item span {
  		font-size: 14px;
  	}

  	.zl-item p {
  		font-size: 28px;
  	} */
  /* 	.el-card__body {
  		padding: 14px 20px;
  		color: #F56C6C;
      font-weight: bold;
      font-size: 20px;
  	} */
  	.utitle{
  		font-weight: bold;
  	}
  	.udata-list{
  		margin-bottom: 10px;
  		line-height: 30px;
  		font-size: 14px;
  	}




   @media screen and (max-width: 1800px) {


     .el-radio{
       margin-right: 5px;
     }
   }
   @media screen and (max-width: 1600px) {
    .h-title,.sbox1 .h-title{font-size: 18px;font-weight: bold;}
    .yl-content{ padding:30px 2px; }
    .yl-content h4{font-size: 12px;white-space: nowrap;}
    .yl-content p { font-size: 20px; white-space: nowrap;}
    .tItem .t-icon{ width: 26px;right: 10px;}
    .el-calendar__button-group .el-button--mini{
      padding: 7px 10px
    }
   }
   @media screen and (max-width: 1400px) {
    .fbox{ height: 120px;}
    .meterBox{ width: 130px;height: 110px;}
    .meter-contet{width: 297px;}
     .outbox{width: 448px;}
   }

</style>



// WEBPACK FOOTER //
// src/views/charts/noPrepayment.vue